// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_vpb","legend":"e_wpb","legendContent":"e_xpb","contentWrapper":"e_ypb","fieldsetContent":"e_zpb"};